var app = angular.module('leonardo');

var FormSearch = function($document, $filter, $q, $rootScope, $timeout, FilterService) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      showList: '=',
      label: '@',
      filter: '@',
      name: '@',
      inline: '=',
      placeholder: '@',
      options: '=',
      multiple: '=',
      mode: '@',
      ngChange: '&',
      ngSubmit: '&'
    },
    templateUrl: 'views/templates/form/form-search.html',
    link: function (scope, elem, attrs, ctrl) {
      scope.ngModelCtrl = ctrl[0];
      scope.formCtrl = scope.$parent.Form ? scope.$parent.Form : { '$submitted' : true };
      scope.name = scope.name ? scope.name : 'value';

      scope.elementsSelected = [];
      scope.comboListVisible = false;
      scope.filterValues = [];
      scope.results = [];
      scope.options_results = [];
      scope.init_options = false;

      scope.ngModelCtrl.$render = function () {
        scope.value = scope.ngModelCtrl.$viewValue;
      };

      scope.initOptions = function() {
        var options = [];
        var name = '';
        angular.forEach(scope.results, function(value, key) {
          if (!angular.isObject(value)) {
            options.push({id:value, name:value});
          }
          else {
            if (scope.mode === 'user') {
              if (value.user) {
                name = !isNull($filter('username')(value.user)) ? $filter('username')(value.user) : value.user.email;
              }
              else {
                name = !isNull($filter('username')(value)) ? $filter('username')(value) : value.email;
              }
            }
            else {
              name = value.name ? value.name : value.label;
            }
            options.push({id:value.id, name: name});
          }
        });
        if (options.length > 0) {
          scope.results = options;
        }

        if (scope.results.length > 8) {
          scope.options_results = angular.copy(scope.results).splice(0,7);
        }
        else {
          scope.options_results = angular.copy(scope.results);
        }
        scope.options_rest = scope.results.length - 8;
        scope.init_options = true;
      };

      scope.getName = function(element){
        var name = '';
        if (!angular.isObject(element)) {
          name = element;
        }
        else if (element.name) {
          name = element.name;
        }
        else if (element.label) {
          name = element.label;
        }
        else if (element.number) {
          name = element.number;
        }
        return name;
      };

      scope.setDefaultValues = function() {
        var array = [];
        $q.when(scope.options).then(function(data){
          if (!isNull(data)) {
            scope.results = (data.results ? data.results : data);
          }
          else {
            scope.results = [];
          }
          scope.elementsSelected = [];
          scope.filterValues = [];
          if (scope.filter){
            if (FilterService.hasFilter(scope.filter)) {
              if(angular.isArray(FilterService.getFilter(scope.filter))) {
                array = [];
                angular.forEach(FilterService.getFilter(scope.filter), function (value) {
                  array.push(value.toString());
                });
                scope.filterValues = array;
              }
              else {
                if (angular.isString(FilterService.getFilter(scope.filter))) {
                  scope.filterValues = FilterService.getFilter(scope.filter).split(',');
                }
                else {
                  scope.filterValues = FilterService.getFilter(scope.filter).toString().split(',');
                }
              }
            }
          }
          if (!isNull(scope.defaultValues)) {
            if (angular.isArray(scope.defaultValues)){
                var array1 = [];
                angular.forEach(scope.defaultValues, function (value) {
                  array1.push(value.toString());
                });
                scope.filterValues = array1;
              }
            else {
              if (angular.isString(scope.defaultValues)) {
                scope.filterValues = scope.defaultValues.split(',');
              }
              else {
                scope.filterValues= scope.defaultValues.toString().split(',');
              }
            }
          }
          var values_valid = [];
          angular.forEach(scope.filterValues, function(value) {
            if (!isNull(value)) {
              values_valid.push(value.toString());
            }
          });
          scope.filterValues = values_valid;
          scope.initOptions();
          scope.initElementsSelected(scope.results);
          var results = scope.filterValues.join(',');
          if (scope.mode === 'array') {
            array = [];
            angular.forEach(scope.elementsSelected, function (result) {
              array.push(result.id);
            });
            scope.ngModelCtrl.$setViewValue(array.length > 0 ? array : undefined);
          }
          else {
            scope.ngModelCtrl.$setViewValue(results.length > 0 ? results : undefined);
          }
        });
      };

      scope.initElementsSelected = function(options){
        if (scope.filterValues.length > 0) {
          angular.forEach(scope.filterValues, function(value) {
            angular.forEach(options, function(element) {
              var element_id = !isNull(element.id) ? element.id.toString() : '';
              if (value === element_id) {
                scope.elementsSelected.push(element);
              }
            });
          });
        }
      };

      scope.getNameElementSelected = function() {
        var name = '';
        if (scope.elementsSelected.length > 0) {
          angular.forEach(scope.elementsSelected, function(element) {
            if (element.name)
              name += element.name + ', ';
            else if (element.label)
              name += element.label + ', ';
          });
        }
        else {
          name += scope.placeholder ? scope.placeholder + ', ' : 'Select ' + scope.filter + ', ';
        }
        return name.slice(0,-2);
      };

      scope.toggleComboList = function(input) {
        if (scope.disabled) {return;}
        if (input && scope.comboListVisible) {return;}
        scope.comboListVisible = !scope.comboListVisible;
        if (scope.comboListVisible) {
          $timeout(function () {
            elem.find('input')[0].focus();
            scope.value_aux = '';
          });
        }
      };

      scope.addElement = function(element) {
        if (scope.disabled) {return;}
        var id = element.id.toString();
        if (!scope.multiple) {
          scope.elementsSelected = [];
          scope.filterValues = [];
          scope.elementsSelected.push(element);
          scope.filterValues.push(id);
        }
        else {
          if (_.contains(scope.filterValues, id)) {
            if (scope.multiple) {
              var index = scope.filterValues.indexOf(id);
              scope.removeElement(index);
            }
            return;
          }
          scope.elementsSelected.push(element);
          scope.filterValues.push(id);
        }

        scope.comboListVisible = false;

        var results = scope.filterValues.join(',');
        if (scope.mode === 'array') {
          var array = [];
          angular.forEach(scope.elementsSelected, function (result) {
            array.push(result.id);
          });
          scope.ngModelCtrl.$setViewValue(array.length > 0 ? array : undefined);
        }
        else {
          scope.ngModelCtrl.$setViewValue(results.length > 0 ? results : undefined);
        }
        if (scope.filter) {
          FilterService.setFilter(scope.filter, results);
        }
        scope.ngChange();
      };

      scope.removeElement = function(index) {
        if (scope.disabled) {return;}
        if (scope.required && scope.elementsSelected.length <= 1) {return;}
        scope.elementsSelected.splice(index, 1);
        scope.filterValues.splice(index, 1);

        if (scope.autoClose) {
          scope.comboListVisible = false;
        }

        var results = scope.filterValues.join(',');
        if (scope.mode === 'array') {
          var array = [];
          angular.forEach(scope.elementsSelected, function (result) {
            array.push(result.id);
          });
          scope.ngModelCtrl.$setViewValue(array.length > 0 ? array : undefined);
        }
        else {
          scope.ngModelCtrl.$setViewValue(results.length > 0 ? results : undefined);
        }

        if (scope.filter) {
          if(scope.filterValues.length === 0) {
            FilterService.removeFilter(scope.filter);
          }
          else {
            FilterService.setFilter(scope.filter, results);
          }
        }

        scope.ngChange();
      };

      scope.showMore = function() {
        if (isNull(scope.value_aux) || (scope.value_aux.length < 2)) {
          scope.options_results = angular.copy(scope.results);
        }
        else {
          scope.options_results = $filter('contains')(scope.value_aux, scope.results);
        }
        scope.options_rest = 0;
      };

      scope.getClasses = function() {
        var classes = [];
        if (!isNull(scope.filterValues) && scope.filterValues.length > 0) {
          classes.push('active');
        }
        if (scope.formCtrl.$submitted && scope.Field[scope.name].$invalid) {
          classes.push('has-error');
        }
        return classes;
      };

      scope.getElementClasses = function(element) {
        var id = !isNull(element.id) ? element.id.toString() : '';
        var classes = [];
        angular.forEach(scope.elementsSelected, function(value){
          var element_id = value.id.toString();
          if (id === element_id) {
            classes.push('active');
          }
        });
        return classes;
      };

      scope.showResults = function() {
        return !isNull(scope.showList) ? scope.showList : (scope.value_aux && scope.value_aux.length >= 2);
      };

      scope.resetValueAux = function () {
        if (scope.comboListVisible) {return;}
        $timeout(function () {
          scope.value_aux = ''
          scope.$apply(scope.value_aux);
        }, 100);
      };

      $timeout(function () {
        scope.$watch('value_aux', function (value) {
          if (isNull(value) || (value.length < 1)) {
            if (scope.results.length > 8) {
              scope.options_results = angular.copy(scope.results).splice(0,7);
            }
            else {
              scope.options_results = angular.copy(scope.results);
            }
            scope.options_rest = scope.results.length - 8;
          }
          else {
            var results = $filter('contains')(value, scope.results);
            if (results.length > 8) {
              scope.options_results = angular.copy(results).splice(0,7);
            }
            else {
              scope.options_results = results;
            }
            scope.options_rest = results.length - 8;
          }
        });
      }, 20);

      scope.$watch('options', function(newValue, oldValue){
        if (newValue === oldValue || !scope.init_options) {return;}
        if (angular.isArray(newValue)) {
          scope.results = newValue;
          if (scope.filter) {
            scope.defaultValues = angular.isArray(FilterService.getFilter(scope.filter)) ?
              FilterService.getFilter(scope.filter).join(',') : FilterService.getFilter(scope.filter);
          }
          scope.setDefaultValues();
          scope.value_aux = '';
        }
      });

      scope.$watch('value', function (newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          if (angular.isArray(newValue)) {
            scope.defaultValues = newValue.join(',');
          }
          else {
            scope.defaultValues = !isNull(newValue) ? newValue : null;
          }
          scope.setDefaultValues();
        }
      });

      elem.find('input').bind("keydown keypress", function (event) {
        if (event.keyCode === 13) {
          if (scope.options_results.length > 0) {
            scope.addElement(scope.options_results[0]);
            scope.$apply();
          }
          event.preventDefault();
        }
      });

      scope.$on('filter-service:filter-changed', function($event, key, value) {
        if ((scope.filter === key) && (value !== scope.ngModelCtrl.$viewValue)) {
          scope.defaultValues = angular.isArray(value) ? value.join(',') : value;
          scope.setDefaultValues();
        }
      });

      scope.$on('filter-service:filter-removed', function($event, key) {
        if ((scope.filter === key) && scope.ngModelCtrl.$viewValue) {
          scope.defaultValues = null;
          scope.setDefaultValues();
        }
      });

      scope.ngModelCtrl.$validators.required = function(modelValue) {
        if (!scope.required) {return true;}
        if(modelValue) {
          if (angular.isArray(modelValue)) {
            return (modelValue.length > 0) ? true : false;
          }
          else {
            return !isNull(modelValue) ? true : false;
          }
        }
        else {
          return false;
        }
      };

      scope.setDefaultValues();

      scope.toggleComboList();
      $timeout(function () {
        elem.find('input')[0].focus();
        scope.value_aux = '';
      },100);
    }
  };
};

app.directive('formSearch', ['$document', '$filter', '$q', '$rootScope', '$timeout', 'FilterService', FormSearch]);